/**
 * Non-breaking space (U+00A0). Authored as a charCode literal so the
 * invisible NBSP character cannot be lost during copy/paste/reformat.
 */
const NBSP = String.fromCharCode(0xa0);

/**
 * Replaces normal spaces with NBSP between digits (thousands separators)
 * and between a digit and its trailing unit (e.g. "150 000 km" stays
 * unbroken horizontally except at the "/"). Multi-value strings such as
 * "7 ans / 150 000 km" remain readable but only break around "/".
 *
 * Использует Unicode property escape `\p{L}` (любая буква в любом языке) —
 * охватывает extended Latin (`ė`, `ł`), Greek (`µ`, `χ`), Cyrillic, CJK и т.д.
 * Регресс на узкий character class отлавливался: см. discussion на MR #787.
 *
 * @param {string|null|undefined} text
 * @returns {string|null|undefined}
 */
export const noBreakUnits = (text) => {
  if (!text) return text;
  return text
    .replace(/(\d)\s+(\d)/g, `$1${NBSP}$2`)
    .replace(/(\d)\s+(\p{L}+)/gu, `$1${NBSP}$2`);
};
